<template>
  <div v-for="totalizador in totalizadores" :key="totalizador.id">
    <div id="card-contagem" v-if="totalizador.isCardSempreVisivel" class="column is-narrow is-6-touch is-12-mobile">
      <div class="is-relative">
        <TrfGlobalLoader type="overlay" :id="`loading-card-${totalizador.tipo}`" class="is-hidden" />
          <CardDashboard
            class="is-clickable"
            :id="`card-${totalizador.nome.split(' ').join('-').toLowerCase()}`"
            :nome="totalizador.nome"
            :quantidade="totalizador.quantidade"
            :bg-color="totalizador.cor"
            :icone="totalizador.icone"
            :isLoading="totalizador.isLoading"
            :tooltip="totalizador.tooltip"
            :quebrarLinhaNaTooltip="true"
            @click="totalizador.acao"
          />
      </div>
    </div>
  </div>
</template>

<script>
import CardDashboard from "../CardDashboard";
import TrfGlobalLoader from "../GlobalLoader";

export default {
  name: "TrfDashboardTotalizadoresCards",
  components: {
    TrfGlobalLoader,
    CardDashboard,
  },
  props: {
    totalizadores : {
      type: Object,
      required: true
    }
  },
};
</script>
<style lang="scss" scoped>
#card-contagem {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
</style>
